const salePercentage = () => {
  const dataOriginal = document.querySelectorAll('[data-original]');
  if (!dataOriginal) return;
  dataOriginal.forEach((el) => {
    const originalPrice = parseFloat(
      el.dataset.original.replace(/[^0-9.]/g, '')
    );
    const salePrice = parseFloat(el.dataset.sale.replace(/[^0-9.]/g, ''));
    const percentage = Math.round(
      ((originalPrice - salePrice) / originalPrice) * 100
    );
    const target = el.querySelector('[data-percentage]');
    target.textContent = `${percentage}%`;
  });
};

const sortByOrder = () => {
  const sort = (target) => {
    const facetFilter = document.querySelector(target);
    if (!facetFilter) return;
    const options = facetFilter.querySelectorAll('option');
    // If option equals 'Featured' move it to bottom of options list
    options.forEach((option) => {
      if (option.textContent.trim() === 'Featured') {
        facetFilter.appendChild(option);
      }
    });
  };
  sort('.facet-filters__sort');
  sort('#SortBy-mobile');
};

export const collections = () => {
  salePercentage();
  sortByOrder();
};
